var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mileage-summary u-container"},[_c('dl',[_c('dt',[_vm._v("적립 마일리지")]),_c('dd',[_vm._v(_vm._s(_vm.useMileage))]),_vm._m(0),_c('dd',[_vm._v(_vm._s(_vm.extinAmt))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dt',[_vm._v(" 소멸 예정"),_c('br'),_vm._v(" 마일리지 ")])
}]

export { render, staticRenderFns }